// Minimal toast bus. <Toast /> (in ui.tsx) subscribes; anything can call toast().
let sink: ((msg: string) => void) | null = null

export const toast = (msg: string) => sink?.(msg)
export const bindToast = (fn: ((msg: string) => void) | null) => {
  sink = fn
}
